import { MdOutlineInbox } from 'react-icons/md';
import { ReportingControllerBaseConfig } from '../../base';
import { TaskListController } from './taskListInterface';
import { TaskListViewProps } from './taskListProps';

export function createTaskListController(
    config: ReportingControllerBaseConfig
): TaskListController {
    const {
        kernel: {
            infra: { formatter },
        },
    } = config;

    return {
        useProps(context, item, props): TaskListViewProps {
            return {
                status:
                    item.tasks.length > 0
                        ? null
                        : {
                              kind: 'empty',
                              label: 'No tasks found',
                              description: 'Get started by creating your first task',
                              Icon: MdOutlineInbox,
                              action: {
                                  label: 'Create task',
                                  link: {
                                      to: props.link.empty.path,
                                  },
                                  button: {
                                      onClick() {
                                          console.log('create task');
                                      },
                                  },
                              },
                          },
                items: item.tasks.map((item) => ({
                    task: item,
                })),
            };
        },
    };
}
